<template>

  <!-- announcement strip just under the fixed navbar -->
  <div id="new-feature-banner" :style="{ marginTop: `${topOffset}px` }" role="link" tabindex="0"
    @click="openTarget()" @keydown.enter="openTarget()">
    <div class="banner-inner">
      <p class="headline"><span class="new-tag">New!</span> Menu auto-import</p>
      <p class="summary">
        Import your menu as PDF or image, and automatically create the digital version, matching your menu style! Auto-translation included.
        <span class="banner-link">Try it →</span>
      </p>
    </div>
  </div>

</template>


<script>
// The homepage hero (HomeBanner) leaves 125px at the top for the fixed navbar; this banner sits right
// under the navbar and takes most of that space (see the negative bottom margin), so the page doesn't grow.
export default {
  name: 'NewFeatureBanner',
  props: {
    signedIn: { type: Boolean, default: false },
    // the fixed bar's full height, measured by Home.vue (the signed-out navbar includes the free-trial strip)
    navbarHeight: { type: Number, default: null }
  },
  methods: {
    // the whole banner is the link: sign up first when signed out, otherwise straight to the menu creator
    openTarget() {
      this.$router.push(this.signedIn ? '/create_menu' : '/sign_up')
    }
  },
  computed: {
    // until it's measured: the app Header (signed in) is 75px, HomeNavbar's main bar 70px
    topOffset() {
      return this.navbarHeight || (this.signedIn ? 75 : 70)
    }
  }
}
</script>


<style scoped>

#new-feature-banner {
  width: 100%;
  box-sizing: border-box;
  background: linear-gradient(to bottom, rgb(105, 70, 141), rgb(67, 42, 106)); /* as the homepage Pricing section */
  color: white;
  margin-bottom: -95px; /* the hero's 125px top margin minus a 30px gap */
  position: relative;
  z-index: 1;
  cursor: pointer;
  transition: filter 0.15s;
}

#new-feature-banner:hover {
  filter: brightness(1.12);
}

#new-feature-banner:hover .banner-link {
  text-decoration: underline;
}

#new-feature-banner:focus-visible {
  outline: 2px solid white;
  outline-offset: -4px;
}

.banner-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  box-sizing: border-box;
  max-width: 1200px;
  margin: 0px auto;
  padding: 16px 5%;
  text-align: center;
}

.new-tag {
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 3px 9px;
  border-radius: 999px;
  background-color: #39B54A;
  color: white;
}

p {
  margin: 0px;
}

.headline {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.3;
}

.summary {
  font-size: 14px;
  line-height: 1.5;
  opacity: 0.95;
}

.banner-link {
  margin-left: 6px;
  font-size: 14px;
  font-weight: 600;
  color: #d9c8ef;
  text-decoration: none;
  white-space: nowrap;
}


@media(max-width: 600px) {
  .headline {
    font-size: 18px;
  }
  .summary, .banner-link {
    font-size: 13px;
  }
}

</style>
